import { createUseStyles } from 'react-jss';

const styles = createUseStyles(theme => ({
  appDetailsHeader: {
    backgroundColor: '#DAEAE4',
  },
  appDetailsHeaderLogo: {
    borderRadius: '5px',
    backgroundColor: theme.palette.background.light,
    boxShadow: '0px 1px 2px grey',
    maxHeight: '350px',
  },
  appDetailsHeaderLogoImg: {
    maxInlineSize: '100%',
    blockSize: 'auto',
    maxWidth: '300px',
  },
  appDetailsTab: {
    minHeight: '500px',
  },
  appDetailsMediaGallery: {
    maxHeight: '150px',
  },
  appDetailsMediaModalImg: {
    maxInlineSize: '100%',
    blockSize: 'auto',
    height: 'auto',
    maxHeight: '80vh',
    maxWidth: '80wh',
  },
  appDetailsMediaModalYoutube: {
    height: '85vh',
    width: '75vw',
  },
  appDetailsYoutubeWrapper: {
    position: 'relative',
    paddingBottom: '56.25%',
    height: '0',
  },
  appDetailsMediaModalYoutubeWrapper: {
    position: 'relative',
    paddingBottom: '56.25%',
    height: '0',
    marginTop: '5vw',
  },
  appDetailsYoutubeFrame: {
    position: 'absolute',
    border: 'none',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
  },
  appDetailsModalLeft: {
    display: 'flex',
    placeItems: 'center',
  },
  appDetailsModalMain: {
    display: 'flex',
    placeItems: 'center',
    justifyContent: 'center',
  },
  appDetailsModalRight: {
    display: 'flex',
    placeItems: 'center',
  },
}));

export default styles;
